const randomToken = () =>
  globalThis.crypto?.randomUUID?.() ?? `gift-${Date.now()}-${Math.random().toString(36).slice(2)}`

const setValue = (form, name, value) => {
  const input = form.elements.namedItem(name)
  if (input instanceof HTMLInputElement) input.value = value
}

const clearGift = (form) => {
  setValue(form, 'properties[_vspots_gift]', '')
  setValue(form, 'properties[_vspots_gift_token]', '')
  setValue(form, 'properties[_vspots_gift_layout]', '')
  setValue(form, 'properties[Als Geschenk]', '')
  setValue(form, 'properties[Geschenkdesign]', '')
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null
  if (target === null) return

  const giftButton = target.closest('[data-vspots-gift-submit]')
  if (giftButton instanceof HTMLButtonElement) {
    const form = giftButton.closest('form')
    if (!(form instanceof HTMLFormElement)) return
    const addButton = form.querySelector('[name="add"]')
    if (!(addButton instanceof HTMLButtonElement) || addButton.disabled) return

    form.dataset.vspotsGiftSubmitting = 'true'
    setValue(form, 'properties[_vspots_gift]', 'true')
    setValue(form, 'properties[_vspots_gift_token]', randomToken())
    setValue(form, 'properties[_vspots_gift_layout]', 'standard')
    setValue(form, 'properties[Als Geschenk]', 'Ja')
    setValue(form, 'properties[Geschenkdesign]', 'Standard')
    addButton.click()
    window.setTimeout(() => {
      delete form.dataset.vspotsGiftSubmitting
      clearGift(form)
    }, 0)
    return
  }

  const addButton = target.closest('button[name="add"]')
  if (!(addButton instanceof HTMLButtonElement)) return
  const form = addButton.closest('form')
  if (form instanceof HTMLFormElement && form.dataset.vspotsGiftSubmitting !== 'true') clearGift(form)
})
